<template>
	<div>
		<card>
			<div class="multiple">
				<div class="child-div">时间区间</div>
				<RadioGroup v-model="timePeriod" @on-change="getList">
					<Radio label="0"><span>不限</span></Radio>
					<Radio label="1"><span>今日</span></Radio>
					<Radio label="2"><span>昨日</span></Radio>
					<Radio label="3"><span>本周</span></Radio>
					<Radio label="4"><span>上周</span></Radio>
					<Radio label="5"><span>本月</span></Radio>
					<Radio label="6"><span>上月</span></Radio>
					<Radio label="7"><span>自定义</span></Radio>
					<DatePicker :value="timePeriodDate" @on-change="timePeriodDateChange" type="daterange"
						placeholder="选择日期" style="width: 200px"></DatePicker>
				</RadioGroup>
			</div>
			<div class="multiple">
				<div class="child-div">统计方式</div>
				<Select v-model="followDepartment" @on-change="search" style="width:150px;" placeholder="部门">
					<Option v-for="item in departmentList" :value="item.value" :key="item.value">{{ item.label }}
					</Option>
				</Select>
				<Button class='ivu-btn-circle' style="margin-left: 30px" type="primary" @click="initSearch">重置</Button>
			</div>
			<!--div class="multiple">
				<div class="child-div">统计方式</div>
				<RadioGroup v-model="statisticsWay">
					<Radio :label="1"><span>媒体代码</span></Radio>
					<Radio :label="2"><span>媒体渠道</span></Radio>
				</RadioGroup>
			</div>
			<div class="multiple">
				<div class="child-div">下级渠道</div>
				<Select v-model="shopId" style="width:200px">
					<Option v-for="item in shopList" :value="item.value" :key="item.value">
						{{ item.label }}
					</Option>
				</Select>
				<Button class='ivu-btn-circle' style="margin-left: 30px" type="primary" @click="getList">搜索</Button>
				<Button class='ivu-btn-circle' style="margin-left: 15px" @click="initSearch">重置</Button>
			</div-->
		</card>
		<div style="width: 100% ; margin-top: 20px;">
			<Table stripe border :columns="columns" :data="datas" ref="table">
				<template slot-scope="{ row }" slot="name">
					<span v-if="statisticsWay==1">{{row.name}}</span>
					<span v-if="statisticsWay==2">{{row.medium_name}}</span>
				</template>
				<template slot-scope="{ row }" slot="nums">
					<span v-if="statisticsWay==1" style="color:#63B3E6;cursor: pointer;"
						@click.stop="clientClick(0,0,row.medium_code_id,1,0)">{{row.nums}}</span>
					<span v-if="statisticsWay==2">{{row.nums}}</span>
				</template>
				<template slot-scope="{ index,row }" slot="start_0">
					<span v-if="statisticsWay==1" style="color:#63B3E6;cursor: pointer;"
						@click.stop="clientClick(0,1,row.medium_code_id,1,0)">{{row.start_0}}</span>
					<span v-if="statisticsWay==2" style="color:#63B3E6;cursor: pointer;"
						@click.stop="clientClick(0,datas[index].medium_id,index)">{{row.start_0}}</span>
					<div>
						<span style="color:#63B3E6;cursor: pointer;"
							@click.stop="clientClick(0,1,row.medium_code_id,1,0)">({{row.start_0_rate}})</span>
					</div>
				</template>
				<template slot-scope="{ index,row }" slot="start_1">
					<span v-if="statisticsWay==1" style="color:#63B3E6;cursor: pointer;"
						@click.stop="clientClick(0,2,row.medium_code_id,1,0)">{{row.start_1}}</span>
					<span v-if="statisticsWay==2" style="color:#63B3E6;cursor: pointer;"
						@click.stop="clientClick(0,2,row.medium_code_id,1,0)">{{row.start_1}}</span>
					<div>
						<span style="color:#63B3E6;cursor: pointer;"
							@click.stop="clientClick(0,2,row.medium_code_id,1,0)">({{row.start_1_rate}})</span>
					</div>
				</template>
				<template slot-scope="{ index,row }" slot="start_2">
					<span v-if="statisticsWay==1" style="color:#63B3E6;cursor: pointer;"
						@click.stop="clientClick(0,3,row.medium_code_id,1,0)">{{row.start_2}}</span>
					<span v-if="statisticsWay==2" style="color:#63B3E6;cursor: pointer;"
						@click.stop="clientClick(2,datas[index].medium_id,index)">{{row.start_2}}</span>
					<div>
						<span style="color:#63B3E6;cursor: pointer;"
							@click.stop="clientClick(0,3,row.medium_code_id,1,0)">({{row.start_2_rate}})</span>
					</div>
				</template>
				<template slot-scope="{ index,row }" slot="start_3">
					<span v-if="statisticsWay==1" style="color:#63B3E6;cursor: pointer;"
						@click.stop="clientClick(0,4,row.medium_code_id,1,0)">{{row.start_3}}</span>
					<span v-if="statisticsWay==2" style="color:#63B3E6;cursor: pointer;"
						@click.stop="clientClick(3,datas[index].medium_id,index)">{{row.start_3}}</span>
					<div>
						<span style="color:#63B3E6;cursor: pointer;"
							@click.stop="clientClick(0,4,row.medium_code_id,1,0)">({{row.start_3_rate}})</span>
					</div>
				</template>
				<template slot-scope="{ index,row }" slot="start_4">
					<span v-if="statisticsWay==1" style="color:#63B3E6;cursor: pointer;"
						@click.stop="clientClick(0,5,row.medium_code_id,1,0)">{{row.start_4}}</span>
					<span v-if="statisticsWay==2" style="color:#63B3E6;cursor: pointer;"
						@click.stop="clientClick(4,datas[index].medium_id,index)">{{row.start_4}}</span>
					<div>
						<span style="color:#63B3E6;cursor: pointer;"
							@click.stop="clientClick(0,5,row.medium_code_id,1,0)">({{row.start_4_rate}})</span>
					</div>
				</template>
				<template slot-scope="{ index,row }" slot="start_5">
					<span v-if="statisticsWay==1" style="color:#63B3E6;cursor: pointer;"
						@click.stop="clientClick(0,6,row.medium_code_id,1,0)">{{row.start_5}}</span>
					<span v-if="statisticsWay==2" style="color:#63B3E6;cursor: pointer;"
						@click.stop="clientClick(5,datas[index].medium_id,index)">{{row.start_5}}</span>
					<div>
						<span style="color:#63B3E6;cursor: pointer;"
							@click.stop="clientClick(0,6,row.medium_code_id,1,0)">({{row.start_5_rate}})</span>
					</div>
				</template>
				<template slot-scope="{ index,row }" slot="start_3_plus">
					<span v-if="statisticsWay==1" style="color:#63B3E6;cursor: pointer;"
						@click.stop="clientClick(0,7,row.medium_code_id,1,0)">{{row.start_4+row.start_5}}</span>
					<span v-if="statisticsWay==2" style="color:#63B3E6;cursor: pointer;"
						@click.stop="clientClick(6,datas[index].medium_id,index)">{{row.start_4+row.start_5}}</span>
					<div>
						<span style="color:#63B3E6;cursor: pointer;"
							@click.stop="clientClick(0,7,row.medium_code_id,1,0)">({{row.start_3_plus_rate}})</span>
					</div>
				</template>
				<template slot-scope="{ index,row }" slot="status_2">
					<span v-if="statisticsWay==1" style="color:#63B3E6;cursor: pointer;"
						@click.stop="clientClick(2,0,row.medium_code_id,1,0)">{{row.status_2}}</span>
					<span v-if="statisticsWay==2" style="color:#63B3E6;cursor: pointer;"
						@click.stop="clientClick(6,datas[index].medium_id,index)">{{row.status_2}}</span>
				</template>
				<template slot-scope="{ index,row }" slot="status_3">
					<span v-if="statisticsWay==1" style="color:#63B3E6;cursor: pointer;"
						@click.stop="clientClick(3,0,row.medium_code_id,1,0)">{{row.status_3}}</span>
					<span v-if="statisticsWay==2" style="color:#63B3E6;cursor: pointer;"
						@click.stop="clientClick(6,datas[index].medium_id,index)">{{row.status_3}}</span>
				</template>

			</Table>
			<Modal v-model="clickJumpClientShow" width="1300" height="500">
				<ClickJumpClient ref="ClickJumpClient" :timePeriod="timePeriod" :timePeriodDate="timePeriodDate"
					:medium_code_id="medium_code_id" :client_type="client_type" :start="start" :timeType="timeType"
					:status="status"></ClickJumpClient>
			</Modal>
		</div>
	</div>
</template>
<script>
	import {
		getAllMediumCode,
		getAllMedium,
		getMediaStatics,
		getAllShop
	} from "../../api/runSet";
	import {
		getDepartmentList,
	} from '@/api/user'
	import {
		getClientNums,
		getClientStatics
	} from "../../api/statics.js";
	import {
		mapGetters
	} from "vuex";
	import ClickJumpClient from '../client/ClickJumpClient.vue';
	export default {
		name: "client_gross_analyse",
		components: {
			ClickJumpClient
		},

		data() {
			return {
				modal: false,
				timePeriod: '5',
				status: '',
				start: '',
				client_type: '',
				statisticsWay: 1,
				timePeriodDate: [],
				departmentList: [],
				timeType: '',
				shopId: '',
				medium_code_id: '',
				followDepartment:'',
				shopList: [],
				datas: [],
				clickJumpClientShow: false,
				columns: [{
						"title": "名称",
						"slot": "name",
						"align": "center",
						"width": 120,
						"fixed": 'left'
					},
					{
						"title": "数量",
						"slot": "nums",
						"align": "center",
						"width": 100,
						"sortable": true
					},
					{
						"title": "0星",
						"slot": "start_0",
						"align": "center",
						"width": 100,
						"sortable": true
					},
					{
						"title": "1星",
						"slot": "start_1",
						"align": "center",
						"width": 100,
					},
					{
						"title": "2星",
						"slot": "start_2",
						"align": "center",
						"width": 100
					},
					{
						"title": "2星+",
						"slot": "start_3",
						"align": "center",
						"width": 100
					},
					{
						"title": "3星",
						"slot": "start_4",
						"align": "center",
						"width": 100
					},
					{
						"title": "4星",
						"slot": "start_5",
						"align": "center",
						"width": 100,
					},
					{
						"title": "3星以上",
						"slot": "start_3_plus",
						"align": "center",
						"width": 100,
					},
					{
						"title": "待跟进",
						"slot": "status_2",
						"align": "center",
						"width": 75,
					},
					{
						"title": "跟进中",
						"slot": "status_3",
						"align": "center",
						"width": 75,
					},
					{
						"title": "签约率",
						"key": "status_sign_rate",
						"align": "center",
						"width": 75,
					},
					{
						"title": "放款率",
						"key": "status_loan_rate",
						"align": "center",
						"width": 75,
					},
					{
						"title": "公共池",
						"key": "pool_nums",
						"align": "center",
						"width": 75,
					},
					{
						"title": "公海",
						"key": "sea_nums",
						"align": "center",
						"width": 60,
					},
					{
						"title": "已上门",
						"key": "the_door_nums",
						"align": "center",
						"width": 70
					},
					{
						"title": "上门率",
						"key": "status_5_rate",
						"align": "center",
						"width": 75,
						"fixed": 'right'
					}
				],
			}
		},
		computed: {
			...mapGetters(['token', 'userInfo'])
		},
		mounted: function() {
			this.loadData();
			this.getList();
		},
		methods: {
			timePeriodDateChange(e) {
				this.timePeriodDate = e;
				this.getList();
			},
			clientClick(status, start, medium_code_id, timeType, client_type) {
				let that = this;
				//time:时间  today：今天 yesterday:昨天 week:本周 thismonth:本月
				//timeType:时间类型 1：客户申请时间 2：分发时间 3、备注更新时间
				that.status = status;
				that.start = start;
				that.medium_code_id = medium_code_id ? medium_code_id : 0;
				that.timeType = timeType;
				that.client_type = client_type;
				that.clickJumpClientShow = true;
				/*
				let routeData = this.$router.resolve({
				    name: 'ClickJumpClient',
				    query: {
						get_uid:get_uid,
						status:status,
						start:start,
						timePeriod:this.timePeriod,
						timePeriodDate:this.timePeriodDate,
						timeType:timeType
				    }
				})
				*/
			},
			/*
			clientClick(start,mediumId,index) {
				if(index == 0 ||mediumId==undefined){
					mediumId = 0;
				}
				window.open('#/shop_client?start='+start+'&mediumId='+mediumId+'&timePeriod='+this.timePeriod+'&timePeriodDate='+this.timePeriodDate+'&statisticsWay='+this.statisticsWay)
			},
			*/
			initSearch() {
				this.mediumCodeId = '';
				this.statisticsWay = 1;
				this.mediumId = '';
				this.followDepartment = '';
				this.timePeriod = 5;
				this.timePeriodDate = [];
			},
			async loadData() {
				let that = this;
				let data = {}
				data.token = this.token;
				let res = await getAllShop(that, data);
				that.shopList = res.data.list;
				res = await getDepartmentList(that, data);
				if (res.code == 1) {
					that.departmentList = res.data.list;
				}
			},
			async getList() {
				let that = this;
				var data = this.$data;
				data.token = this.token;
				let res = await getClientStatics(that, data);
				if (res.data.list !== null) {
					that.datas = res.data.list;
				}

			},
			search() {
				this.getList();
			}
		},


	}
</script>
<style scoped lang="less">
	.red {
		color: red;
	}

	.multiple {
		display: flex;
		justify-content: left;
		margin-top: 10px;
		align-items: center;

		.child-div {
			width: 70px;
			height: 20px;
			margin-right: 30px;
			text-align-last: justify;
		}
	}

	.hong {
		color: #F56171;
		font-weight: bold;
	}

	.lan {
		color: #124386;
		font-weight: bold;
	}

	.sousuo {
		width: 100%;
		display: flex;
		justify-content: space-between;
	}

	.yl-flex {
		display: flex;
	}

	.flex_between {
		align-items: flex-start;
		display: flex;
		justify-content: space-between;
		margin-bottom: 10px;
	}

	.green-bg {
		background: #18bc9c;
	}

	.blue-bg {
		background: #54A1F3;
	}

	.person {
		font-size: 14px;
		color: white;
		border-radius: 50%;
		width: 22px;
		height: 20px;
	}

	.in-block {
		display: inline-block;
	}
</style>